<button
  mat-button
  [disabled]="disabled"
  class="{{ btnClass ? btnClass : 'ib-btn-secondary ib-btn-outline' }}"
  (click)="openModal()"
>
  <i class="material-icons">camera_alt</i> Add Photo
</button>

<ng-template #modalTmpl>
  <h1 mat-dialog-title>Photo of the Document</h1>

  <div mat-dialog-content class="max-h-80vh py-24px px-16px">
    <div class="text-center">Make a photo of the document.</div>

    <div *ngIf="error" class="mt-16px mb-16px">
      <span>{{ error }}</span>
    </div>

    <ng-container *ngIf="multipleWebcamsAvailable">
      <div class="mt-24px ml-8px"><b>Select Camera: </b></div>
      <mat-radio-group
        aria-label="Select a Camera"
        class="flex flex-col"
        [(ngModel)]="selectedDeviceId"
        (change)="deviceSelected()"
      >
        <mat-radio-button
          *ngFor="let camera of cameras"
          [value]="camera.deviceId"
          [checked]="camera.deviceId === selectedDeviceId"
        >
          {{ camera.label }}
        </mat-radio-button>
      </mat-radio-group>
    </ng-container>

    <div class="flex justify-center items-center mt-16px">
      <webcam
        *ngIf="showWebcam"
        [height]="600"
        [width]="600"
        [trigger]="triggerObservable"
        (imageCapture)="handleImage($event)"
        [allowCameraSwitch]="multipleWebcamsAvailable"
        [switchCamera]="nextWebcamObservable"
        [videoOptions]="videoOptions"
        [imageQuality]="1"
        (cameraSwitched)="cameraWasSwitched($event)"
      ></webcam>

      <div
        *ngIf="!cameraIsVisible"
        class="absolute top-0 bottom-0 right-0 left-0 flex justify-center items-center"
      >
        <mat-spinner></mat-spinner>
      </div>
    </div>

    <div class="mt-16px flex justify-center items-center">
      <button
        mat-button
        class="ib-btn-secondary"
        [disabled]="
          photos?.length === 1 || !selectedDeviceId || !cameraIsVisible
        "
        (click)="triggerSnapshot()"
      >
        <i class="material-icons">camera_alt</i>Take A Snapshot
      </button>
    </div>

    <div *ngIf="photos?.length" class="mt-24px text-semibold">
      Photos
      <ng-container>({{ photos.length }})</ng-container>:
    </div>

    <ib-selected-docs
      [docsMainFormGroup]="photosForm"
      [docs]="photos"
      [docsFormGroupsMap]="photosFormGroupsMap"
      [setFocusToAdded]="true"
      (removeDoc)="removePhoto($event)"
    >
    </ib-selected-docs>
  </div>

  <div
    mat-dialog-actions
    class="border-t border-border-d flex justify-end items-center"
  >
    <div class="flex justify-end items-center grow">
      <button
        mat-button
        class="ib-btn-outline ib-btn-secondary mr-16px"
        (click)="cancel()"
      >
        Cancel
      </button>
      <button
        mat-button
        class="ib-btn-secondary"
        [disabled]="!photos?.length || photosForm.invalid"
        (click)="confirm()"
      >
        Confirm
      </button>
    </div>
  </div>
</ng-template>
